import Cookies from 'universal-cookie';
import jwt_decode from 'jwt-decode';
import {
  API_ALL_TOGGLES_REQUEST,
  API_ALL_TOGGLES_SUCCESS,
  API_ALL_TOGGLES_FAILURE,
} from 'common/types';

const initialState = {
  toggles: [],
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [API_ALL_TOGGLES_REQUEST]: (state) => {
    return {
      ...state,
      toggles: null,
      loading: true,
    };
  },
  [API_ALL_TOGGLES_SUCCESS]: (state, action) => {
    return {
      ...state,
      toggles: action.payload,
      loading: false,
    };
  },
  [API_ALL_TOGGLES_FAILURE]: (state, action) => {
    return {
      ...state,
      error: true,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
